import React from "react";

import { Link, useLocation } from "react-router-dom"

import { useTranslation } from "react-i18next";

function MobileMenu({ toggleMenu, isOpen, isScrolledPastHeight, MainMenu, currentLang}) {

    const location = useLocation();

    const { t } = useTranslation();

    const serviceLinks = [
        { to: '/services', label: t('header.add.1') },
        { to: '/cars', label: t('header.add.2') },
        { to: '/agro', label: t('header.add.7') },
        { to: '/naturalres', label: t('header.add.3') },
        { to: '/industrial', label: t('header.add.5') },
        { to: '/investments', label: t('header.add.6') },
        { to: '/realestate', label: t('header.add.8') },
        { to: '/marketing', label: t('header.add.9') },
        { to: '/homelife', label: t('header.add.10') },
        { to: '/construction', label: t('header.add.11') },
    ];

    const isServicesPath = serviceLinks.some((link) => location.pathname === link.to);

    const topItemClass = 'inter text-[16px] font-[400] leading-[1.5] text-[rgba(0,0,0,0.70)]';
    const serviceItemClass = 'inter text-[16px] font-[400] leading-[1.5]';
    const MenuDot = ({ active }) => (
        <svg className="h-[16px] w-[16px] shrink-0" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path d="M8 11C8.79565 11 9.55871 10.6839 10.1213 10.1213C10.6839 9.55871 11 8.79565 11 8C11 7.20435 10.6839 6.44129 10.1213 5.87868C9.55871 5.31607 8.79565 5 8 5C7.20435 5 6.44129 5.31607 5.87868 5.87868C5.31607 6.44129 5 7.20435 5 8C5 8.79565 5.31607 9.55871 5.87868 10.1213C6.44129 10.6839 7.20435 11 8 11Z" fill={active ? '#D14507' : '#C7C7C7'} />
        </svg>
    );

    return (
        <div>
            <button
                type="button"
                className={`relative z-[900] flex h-[44px] w-[60px] items-center justify-center ${currentLang === 'ar' ? 'ml-[-16px]' : 'mr-[-16px]'}`}
                onClick={toggleMenu}
                aria-label={isOpen ? 'Close menu' : 'Open menu'}
                aria-expanded={isOpen}
            >
                <svg className={`ham hamRotate ham1 ${isOpen ? 'active' : ''}`} viewBox="0 0 100 100" width="80" aria-hidden="true">
                    <path
                        className="line top"
                        d="m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40"
                    />
                    <path
                        className="line middle"
                        d="m 30,50 h 40"
                    />
                    <path
                        className="line bottom"
                        d="m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656 l 0.252538,40"
                    />
                </svg>
            </button>
            <div className={`fixed top-0 bottom-0 w-full h-full md:w-[520px] xl:w-[620px] bg-white z-50 ltr:right-0 rtl:left-0 transition-all duration-500 transform ${isOpen ? '' : 'translate-x-[1000px] rtl:translate-x-[-1000px]'}`}>
                <nav className="mx-[20px] mt-[60px] flex flex-col pt-[18px] transition-all md:mx-[48px] xl:mx-[64px] xl:mt-[54px] xl:pt-[26px]">
                    <Link to="/" onClick={toggleMenu} className="flex items-center gap-[26px] border-b border-[#E9E9E9] pb-[18px] xl:gap-[34px] xl:pb-[24px]">
                        <MenuDot active={location.pathname === '/'} />
                        <span className={topItemClass}>{t('header.0')}</span>
                    </Link>

                    <div className="py-[18px] xl:py-[24px]">
                        <div className="flex items-center gap-[26px] xl:gap-[34px]">
                            <MenuDot active={isServicesPath} />
                            <span className={topItemClass}>{t('header.1')}</span>
                        </div>

                        <div className="ml-[40px] flex flex-col xl:ml-[53px] mt-[15px] gap-[12px]">
                            {serviceLinks.map((link) => {
                                const isActive = location.pathname === link.to;

                                return (
                                    <Link key={link.to} to={link.to} onClick={toggleMenu} className="flex items-center gap-[18px] xl:gap-[24px]">
                                        <span className={`h-[1px] w-[22px] ${isActive ? 'bg-[#D14507]' : 'bg-[#0000004D]'}`}></span>
                                        <span className={`${serviceItemClass} ${isActive ? 'text-[#D14507]' : 'text-[rgba(0,0,0,0.70)]'}`}>
                                            {link.label}
                                        </span>
                                    </Link>
                                );
                            })}
                        </div>
                    </div>

                    <Link to="/about" onClick={toggleMenu} className="flex items-center gap-[26px] border-t border-[#E9E9E9] pt-[18px] xl:gap-[34px] xl:pt-[24px]">
                        <MenuDot active={location.pathname === '/about'} />
                        <span className={topItemClass}>{t('header.2')}</span>
                    </Link>
                </nav>
            </div>
        </div>
    );
}

export default MobileMenu;
